import { Controller } from '@hotwired/stimulus'
import { get } from '@rails/request.js'

export default class extends Controller {
  static targets = [
    'showItemsButton',
    'hideItemsButton',
    'itemsContainer',
    'addAllButton',
  ]
  static classes = ['hidden', 'disabled']

  showItems() {
    event.preventDefault()

    get(event.currentTarget.href, { responseKind: 'turbo-stream' }).then(
      (response) => {
        if (response.ok) {
          this.showItemsButtonTarget.classList.add(this.hiddenClass)
          this.hideItemsButtonTarget.classList.remove(this.hiddenClass)
        }
      }
    )
  }

  hideItems() {
    this.itemsContainerTarget.innerHTML = '' // Clear up the shipment's result area
    this.showItemsButtonTarget.classList.remove(this.hiddenClass)
    this.hideItemsButtonTarget.classList.add(this.hiddenClass)
    this.addAllButtonTarget.classList.remove(this.disabledClass)
  }

  manageAddAllButton({ detail: { content } }) {
    if (content.count < 1) {
      this.addAllButtonTarget.classList.add(this.disabledClass)
    }
  }
}
